import plantImage from '@assets/images/plant.svg'
import { Card, Loading } from '@components'
import StatusBadge from '@components/PlantCard/StatusBadge/StatusBadge'
import { useUpdateSummaryDashboardActive } from '@hooks'
import { SummaryDashboard } from '@types'
import type { FC } from 'react'

type AdminDashboardCardProp = {
  board: Partial<SummaryDashboard>;
  index: number
  onClick: (dashboardId: string) => void
  isAllowUpdateStatus?: boolean
}

const AdminDashboardCard: FC<AdminDashboardCardProp> = ({ board, index, onClick, isAllowUpdateStatus }) => {
  const { mutateAsync, isLoading } = useUpdateSummaryDashboardActive()

  const handleStatusChange = async (dashboardId: string, status: boolean) => {
    try {
      await mutateAsync({ dashboardId, isActive: status })
    } catch {
      console.error('Failed to update dashboard status. Please try again.')
    }
  }

  const { id, name = 'Board Name', image = plantImage } = board
  const isActive = board.is_active ?? true

  return (
    <div className='box' onClick={() => !isLoading && onClick(id.toString())} key={`${id}-card`}>
      <Card
        animationOrder={index + 1}
        content={
          <div className='content'>
            {isLoading && <Loading size={40} />}
            {isAllowUpdateStatus && <StatusBadge isActive={isActive} onStatusChange={(status) => handleStatusChange(id.toString(), status)} />}
            <img className='img' src={image} alt={image} />
            <div className='name'>{name}</div>
          </div>
        }
      />
    </div>
  )
}

export default AdminDashboardCard
